import * as React from "react";
import * as ToastPrimitives from "@radix-ui/react-toast";
import { X } from "lucide-react";
import { cn } from "../../lib/utils";
const ToastProvider = ToastPrimitives.Provider;
const ToastViewport = React.forwardRef(({ className, ...props }, ref) => (<ToastPrimitives.Viewport ref={ref} className={cn("va-toast-viewport", className)} {...props}/>));
ToastViewport.displayName = ToastPrimitives.Viewport.displayName;
const Toast = React.forwardRef(({ className, variant, ...props }, ref) => {
    const variantClass = variant === "destructive" ? "va-toast--destructive" : "";
    return <ToastPrimitives.Root ref={ref} className={cn("va-toast", variantClass, className)} {...props}/>;
});
Toast.displayName = ToastPrimitives.Root.displayName;
const ToastAction = React.forwardRef(({ className, ...props }, ref) => (<ToastPrimitives.Action ref={ref} className={cn("va-button va-button--outline va-button--sm", className)} {...props}/>));
ToastAction.displayName = ToastPrimitives.Action.displayName;
const ToastClose = React.forwardRef(({ className, ...props }, ref) => (<ToastPrimitives.Close ref={ref} className={cn("va-toast-close", className)} toast-close="" {...props}>
    <X size={16}/>
  </ToastPrimitives.Close>));
ToastClose.displayName = ToastPrimitives.Close.displayName;
const ToastTitle = React.forwardRef(({ className, ...props }, ref) => (<ToastPrimitives.Title ref={ref} className={cn("va-card-title", className)} {...props}/>));
ToastTitle.displayName = ToastPrimitives.Title.displayName;
const ToastDescription = React.forwardRef(({ className, ...props }, ref) => (<ToastPrimitives.Description ref={ref} className={cn("va-card-description", className)} {...props}/>));
ToastDescription.displayName = ToastPrimitives.Description.displayName;
export { ToastProvider, ToastViewport, Toast, ToastTitle, ToastDescription, ToastClose, ToastAction, };
